import {
  Avatar,
  Box,
  Button,
  CssBaseline,
  Icon,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import { APP_ICONS, APP_IMAGES, APP_LOGO } from "../../assets";
import ADMIN_ROUTES from "../../routes";
import MuiDrawer from "@mui/material/Drawer";
import { useLocation, useNavigate } from "react-router-dom";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AppContext from '../context/appContext';
const drawerWidth = 250;

const openedMixin = (theme) => ({
  width: drawerWidth,
  borderRadius: "12px",
  boxShadow: "0px 0px 20px 0px #003B951F",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  borderRadius: "12px",
  boxShadow: "0px 0px 20px 0px #003B951F",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(1, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

const useStyle = {
  activeTab: {
    bgcolor: "primary.main",
    color: "#ffffff !important",
    mx: 1,
    my: 0.5,
    borderRadius: 2,
    "&:hover": {
      bgcolor: "primary.main",
    },
    "& .MuiListItemText-primary": {
      color: "secondary.light",
    },
  },
  inActiveTab: {
    // bgcolor: "primary.main",
    // color: "#ffffff !important",
    margin: 0.5,
    borderRadius: 2,

    "&:hover": {
      // bgcolor: "primary.main",
    },
    "& .MuiListItemText-primary": {
      // color: "customColor.tundora",
    },
  },
};

export default function NavigationDrawer(props) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const { pathname } = useLocation();
  const { logout } = React.useContext(AppContext);

  const handleToggleDrawer = () => {
    setOpen((prev) => !prev);
  };

  const handleNavigation = (path) => {
    if (open) {
      setOpen(true); // Close the drawer only if it's currently open
      navigate(path); // Then navigate to the new route
    } else {
      navigate(path);
      setOpen(false); // Close the drawer only if it's currently open
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <Stack direction={"row"} gap={1} my={0}>
            {open ? (
              <img
                src={APP_LOGO.circularLogo}
                style={{
                  width: 58,
                  height: 58,
                }}
              />
              
            ) : (
              <img
                src={APP_LOGO.circularLogo}
                style={{
                  width: 50,
                  height: 50,
                  margin: "0 5px"
                }}
              />
            )}
          </Stack>
        </DrawerHeader>

        <IconButton
          onClick={handleToggleDrawer}
          sx={{
            position: "fixed",
            top: "70px",
            left: open ? `${drawerWidth - 20}px` : "50px", // Position icon relative to drawer width
            zIndex: 1300,
            transition: "left 0.3s", // Smooth transition for moving icon
            cursor: "pointer",
            backgroundColor: 'primary.light',
            borderRadius: "9px",
            "&:hover": {
              backgroundColor: "#800000", // Change background color on hover
              color: '#964B00', // Change text color on hover
            },
          }}
        >
          {open ? <ChevronLeftIcon sx={{ color: "#F5F5DC" }} /> : <ChevronRightIcon sx={{ color: "#F5F5DC" }} />}
        </IconButton>

        <List sx={{ mt: 0 }}>
          {ADMIN_ROUTES.map((route, index) => (
            <>
              {/* {open && (
                <Typography
                  mx={3}
                  fontSize={"0.75rem"}
                  color="customColor.dustyGray"
                  fontWeight={600}
                  my={(index === 1 || index === 3 || index === 5) && 1}
                  display={
                    index === 1 || index === 3 || index === 5 ? "block" : "none"
                  }
                >
                  {index === 1
                    ? "USERS MANAGEMENT SYSTEM"
                    : index === 3
                      ? "Residential Jobs  E-WALLET"
                      : index === 5
                        ? "SPONSORED"
                        : null}
                </Typography>
              )} */}

              <ListItem key={index} disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  onClick={() => handleNavigation(route.path)}
                  className="active-tab"
                  sx={[
                    {
                      minHeight: 48,
                      px: 2.5,
                      ...(route.path === pathname
                        ? useStyle.activeTab
                        : useStyle.inActiveTab),
                    },
                    open
                      ? {
                        justifyContent: "initial",
                      }
                      : {
                        justifyContent: "center",
                      },
                  ]}
                >
                  <ListItemIcon
                    sx={[
                      {
                        minWidth: 0,
                        justifyContent: "center",
                      },
                      open
                        ? {
                          mr: 2,
                        }
                        : {
                          mr: "auto",
                        },
                    ]}
                  >
                    {/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
                    <div>
                      {route.path === pathname ? route.activeIcon : route.inActiveIcon}
                    </div>
                  </ListItemIcon>
                  <ListItemText
                    primary={route.name}
                    sx={{
                      // "& .MuiTypography-root": {
                      //   color: "customColor.tundora",
                      // },
                      ...(open
                        ? {
                          opacity: 1,
                        }
                        : {
                          opacity: 0,
                        }),
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </>
          ))}

          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() => handleNavigation("/profile")}
              className="active-tab"
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                  ...(pathname === "/profile" ? useStyle.activeTab : useStyle.inActiveTab),
                },
                open
                  ? {
                    justifyContent: "initial",
                  }
                  : {
                    justifyContent: "center",
                  },
              ]}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                      mr: 2,
                    }
                    : {
                      mr: "auto",
                    },
                ]}
              >
                {/* Replace with appropriate profile icon */}
                <div>
                  {pathname === "/profile" ? <Avatar src={APP_IMAGES.dumyUserImg} /> : <Avatar src={APP_IMAGES.dumyUserImg} />}
                </div>
              </ListItemIcon>
              <ListItemText
                primary="Profile"
                sx={{
                  ...(open
                    ? {
                      opacity: 1,
                    }
                    : {
                      opacity: 0,
                    }),
                }}
              />
            </ListItemButton>
          </ListItem>
        </List>

        {open ? (
          <>
            <Stack spacing={2} sx={{ m: "auto" }}>
              <Button
                variant="contained"
                onClick={handleLogout}
                sx={{ height: 45, width: 232 }}
                endIcon={<img src={APP_ICONS.logoutIconWhite} width={20} />}
              >
                Logout
              </Button>
            </Stack>
          </>
        ) : (
          <IconButton
            onClick={handleLogout}
            sx={{
              backgroundColor: "primary.main",
              mx: 1,
              mt: 4,
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "primary.main",
              },
            }}
          >
            <img src={APP_ICONS.logoutIconWhite} width={20} />
          </IconButton>
        )}
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 3, overflow: "auto" }}>
        {props.children}
      </Box>
    </Box>
  );
}
